import Promise from 'bluebird';
import { useCallback, useState } from 'react';

import { BaseResultType } from '../types';

export const filterPredicateFactory = <ResultType extends BaseResultType>(query: string) => ((result: ResultType) => result.name.toLowerCase().includes(query.toLowerCase()));

export const useFilterOnClient = <ResultType extends BaseResultType>(originalFn: (query: string) => Promise<ResultType[]>) => {
  const [cachedResults, setCachedResults] = useState<ResultType[]>();

  return useCallback((query: string) => {
    const fetchResults = cachedResults
      ? Promise.resolve(cachedResults)
      : originalFn('');

    const filterPredicate = filterPredicateFactory(query);

    return fetchResults.then((results) => {
      setCachedResults(results);

      const filteredResults = results.filter(filterPredicate);

      return filteredResults;
    });
  }, [cachedResults, originalFn]);
};
